import styled from 'styled-components';
import {mobileMedia, BGImageCenter, getStaticImage, scrollbar} from '../../../globalVariables/GlobalVariables';
import {dFlexCenter, dFlexColumn} from '../../../globalVariables/GlobalFlex';
import {container as modeBtnContainer} from '../../../component/modeBtn/ModeBtn.css';
import {getFontSize, getFontWeight, getToken, getSpacing} from '@tickchak/react-share/app';
import zIndex from '../../../globalVariables/zIndex';
import { ListStyled } from '@tickchak/react-share/app';

const ANIMATION_DURATION = 400;
const IMAGE_SIZE = 139;
const IMAGE_OFFSET = 44;

export const POPUP_WIDTH = 370;
export const POPUP_HEIGHT = 590;
export const POPUP_BOTTOM = 19;
export const POPUP_INLINE_END = 19;

export const backdrop = styled.div`
    backdrop-filter: blur(8px) brightness(0.6);
    -webkit-backdrop-filter: blur(8px) brightness(0.6);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: ${zIndex.dropDown - 1};
    opacity: 0;
    pointer-events: none;
    transition: opacity ${ANIMATION_DURATION}ms;
    
    &.show {
        opacity: 1;
        pointer-events: auto;
    }
`;

export const wrapper = styled.div<{$showImage: boolean; $isLoginPage?: boolean}>`
    position: relative;

    /* Login page specific styles */
    ${({$isLoginPage}) => $isLoginPage && `
        position: fixed;
        inset-inline-end: 0;
        bottom: 0;
        z-index: ${zIndex.baseHighest};
    `}
    
    &::before {
        content: '';
        ${BGImageCenter(getStaticImage('app/helpMan.png'), 'contain')};
        position: fixed;
        width: ${IMAGE_SIZE}px;
        height: ${IMAGE_SIZE}px;
        bottom: calc(${POPUP_BOTTOM}px + min(${POPUP_HEIGHT}px, 80vh));
        inset-inline-end: calc(${POPUP_INLINE_END}px + ${POPUP_WIDTH}px - ${IMAGE_SIZE}px - ${IMAGE_OFFSET}px);
        pointer-events: none;
        z-index: ${zIndex.basicModal};
        opacity: ${({$showImage}) => $showImage ? 1 : 0};
        transform: ${({$showImage}) => $showImage ? 'scale(1)' : 'scale(0.95)'};
        transition: opacity ${ANIMATION_DURATION}ms, transform ${ANIMATION_DURATION}ms;
        
        ${mobileMedia} {
            bottom: min(${POPUP_HEIGHT}px, 70vh);
            transition: opacity ${ANIMATION_DURATION}ms, transform ${ANIMATION_DURATION}ms, bottom 400ms;
            z-index: ${zIndex.upperModal};
        }
    }
    
    ${modeBtnContainer} {
        align-self: self-end;
    }

    
    >div{
        ${scrollbar}

    }

    ${ListStyled.ListLayer} {
        height: 100%;
    }
`;

export const headerSubtitle = styled.div`
    ${dFlexCenter}
    gap: ${getSpacing('spaceXs')};
    font-size: ${getFontSize('caption')};
    font-weight: ${getFontWeight('regular')};
    color: ${getToken('color.text.subtle')};
    padding: 0 ${getSpacing('spaceMd')} ${getSpacing('spaceSm')};
    height: fit-content;
    

    margin-top: calc(var(--space-sm) - var(--space-lg));
    padding-inline-start: var(--space-xl);
    svg {
        width: 14px;
        height: 14px;
        flex-shrink: 0;
    }
`;
export const showAll = styled.div`
    padding-inline: var(--space-lg);
    justify-items: self-end;
    padding-top: var(--space-lg);
    
    + div {
            padding-top: 10px;
            padding: var(--space-lg);
        + div { 
            max-height: 100%;
            ${scrollbar}
        }
    }
`;

export const moreResults = styled.div`
    font-size: ${getFontSize('caption')};
    color: ${getToken('color.text.subtle')};
    padding: ${getSpacing('spaceSm')} 0;
    text-align: center;
`;

export const videos = styled.div`
    ${dFlexColumn}
`;

export const headerActionsContainer = styled.div`
    ${dFlexCenter}
    gap: ${getSpacing('spaceSm')};
    padding: ${getSpacing('spaceMd')};
    background: ${getToken('color.brand.subtle')};
    border-radius: 100px;
    width: fit-content;
    inset-inline-end: 0;
    align-self: end;
    margin-top: calc(-89px + var(--space-lg) + 7px);
    margin-inline-end: var(--space-lg);
`;
